import TextField from "@/components/form/textField/TextField"
import { NumericStepperProps } from "@/types/components/numericStepper"
import { NumericFormat } from "react-number-format"

import classNames from "classnames"

import "./numericStepper.scss"
import { useEffect, useRef, useState } from "react"
import IconButton from "@/components/button/IconButton"

export default function NumericStepper({
  className,
  value,
  step = "1",
  min,
  max,
  ref,
  onChange,
  ...props
}: NumericStepperProps) {
  const [localValue, setValue] = useState(value || 0)
  const createdRef = useRef<HTMLInputElement>(null) || ref
  const inputRef = ref || createdRef

  useEffect(() => {
    if (value !== undefined) {
      setValue(value)
    }
  }, [value])

  const clampValue = (val: number): number => {
    let result = val
    if (min !== undefined && result < min) result = min
    if (max !== undefined && result > max) result = max
    return result
  }

  const isAllowedValue = ({ floatValue }: { floatValue: number | undefined }): boolean => {
    if (floatValue === undefined) return true
    if (min !== undefined && floatValue < min) return false
    if (max !== undefined && floatValue > max) return false
    return true
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/[,]/g, "")
    const numericValue = newValue ? Number(newValue) : undefined

    setValue(numericValue || 0)
    onChange(numericValue)
  }

  const handleIncrement = () => {
    const newValue = clampValue(Number(localValue) + Number(step))
    setValue(newValue)
    onChange(newValue)
  }

  const handleDecrement = () => {
    const newValue = clampValue(Number(localValue) - Number(step))
    setValue(newValue)
    onChange(newValue)
  }

  return (
    <NumericFormat
      {...props}
      value={localValue}
      className={classNames("NumericStepperCont", className)}
      type="text"
      customInput={TextField}
      onChange={handleChange}
      inputRef={inputRef}
      thousandSeparator=","
      isAllowed={isAllowedValue}
      appendIcon={
        <>
          <IconButton
            className="numeric-btn"
            onClick={handleDecrement}
            type="ghost"
            size="md"
            icon="subtract"></IconButton>
          <IconButton
            className="numeric-btn"
            onClick={handleIncrement}
            type="ghost"
            size="md"
            icon="add"></IconButton>
        </>
      }
      slotProps={{
        ...props.slotProps,
        htmlInput: {
          ...props.slotProps?.htmlInput,
          step: step,
        },
      }}
    />
  )
}
